import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'
import store from '../store/index'

firebase.initializeApp({
  apiKey: 'AIzaSyDFI4VYkwKXVsC6MfeT6A8Qu8E1Efcr3ZA',
  authDomain: 'podbae-549cb.firebaseapp.com',
  databaseURL: 'https://podbae-549cb.firebaseio.com',
  projectId: 'podbae-549cb',
  storageBucket: 'podbae-549cb.appspot.com',
  messagingSenderId: '253594897340',
  appId: '1:253594897340:web:c633be4d97df8233'
})

const db = firebase.firestore()
const storage = firebase.storage()
const auth = firebase.auth()

auth.onAuthStateChanged(user => {
  store.commit('setUser', user)
})

const { TimeStamp, GeoPoint } = firebase.firestore
export { TimeStamp, GeoPoint, storage, auth, db }
